var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 135,
    viewBox: "0 0 134 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 0.907227C104.003 0.907227 134 30.9042 134 67.9072C134 104.91 104.003 134.907 67 134.907C29.997 134.907 0 104.91 0 67.9072C0 30.9042 29.997 0.907227 67 0.907227V0.907227Z",
    fill: "#151447"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0916 67.1408C16.9492 67.4331 17.0137 67.7841 17.2506 68.0067L66.4794 115.18C66.7699 115.458 67.2285 115.458 67.519 115.18L116.748 68.0097C116.985 67.787 117.049 67.4361 116.907 67.1438L98.6791 28.8563C98.5589 28.5937 98.2964 28.4256 98.0076 28.4264H35.9967C35.7065 28.4227 35.4412 28.5899 35.3193 28.8533L17.0916 67.1408V67.1408Z",
    fill: "#50AF95"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7244 71.0728C48.2044 70.5221 38.8594 68.3426 38.8594 65.7332C38.8594 63.1238 48.2044 60.9473 60.7244 60.3877V68.9022C61.5432 68.9611 63.8875 69.0996 67.1273 69.0996C71.0149 69.0996 72.9617 68.9376 73.3122 68.9052V60.3936C85.8056 60.9502 95.1301 63.1297 95.1301 65.7332C95.1301 68.3368 85.8204 70.5192 73.3239 71.0728C72.9705 71.0993 71.1445 71.2083 67.0713 71.2083C63.8316 71.2083 61.5314 71.1111 60.7244 71.0728V71.0728ZM90.7594 51.8936V40.2749H43.2889V51.8936H60.7214V59.5099C46.5521 60.1608 35.8965 62.9676 35.8965 66.3309C35.8965 69.6944 46.5521 72.4982 60.7214 73.152V97.5676H73.3209V73.1432C87.4578 72.4923 98.0959 69.6885 98.0959 66.328C98.0959 62.9676 87.4697 60.1667 73.3239 59.5129V51.8936H90.7594V51.8936Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.2df57f87eb6635d15b33c379afbc11a9.svg";
export { ForwardRef as ReactComponent };